export default __webpack_public_path__ + "960acf34ab7e80395c2f8333a4ab0f76.png";